import { MessageCircle } from "lucide-react";
import { BUSINESS } from "@/lib/constants";

export const WhatsAppFloat = () => {
  return (
    <a
      href={BUSINESS.whatsapp}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-btn"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-5 right-5 sm:bottom-6 sm:right-6 z-50 group"
    >
      <span className="absolute inset-0 rounded-full bg-green-500 animate-pulse-ring" />
      <span className="relative flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-green-500 hover:bg-green-600 text-white shadow-xl shadow-green-500/30 transition-all group-hover:scale-105">
        <MessageCircle size={26} fill="currentColor" strokeWidth={0} />
      </span>
      <span className="hidden sm:block absolute right-full top-1/2 -translate-y-1/2 mr-3 bg-navy text-white text-xs font-semibold px-3 py-2 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap shadow-lg">
        Chat with us
      </span>
    </a>
  );
};
